export const diagramTypes = {
  line: "line",
  bar: "bar",
  spider: "spider",
};

export const evaluationTypes = {
  question: "question",
  subdimension: "subdimension",
};

export const perspectives = {
  teacher: "Lehrer*innen",
  expert: "Beobachter*innen",
  student: "Schüler*innen",
};

export const perspectiveLabels = new Map();
perspectiveLabels.set(perspectives.teacher, "Lehrpersonen");
perspectiveLabels.set(perspectives.expert, "Beobachter*innen");
perspectiveLabels.set(perspectives.student, "Schüler*innen");

export const perspective_colors = {
  [perspectives.teacher]: "#0028a5",
  [perspectives.expert]: "#dc6027",
  [perspectives.student]: "#2a7f62",
};

export const question_keys = {
  [perspectives.teacher]: "teacher_question",
  [perspectives.expert]: "expert_question",
  [perspectives.student]: "student_question",
};
